import React from 'react'

const Loops = () => {
    return (
        <div className='container'>
            <h1>Python for Loop</h1>
            <p>There are two types of loops in Python, for and while.</p>
            The "for" loop For loops can iterate over a sequence of numbers using the "range" and "xrange" functions. The difference between range and xrange is that the range function returns a new list with numbers of that specified range, whereas xrange returns an iterator, which is more efficient. (Python 3 uses the range function, which acts like xrange). Note that the range function is zero based.


For loops iterate over a given sequence. Here is an example:
<div className='containers'> 
<code className='comment'> # Prints out the numbers 0,1,2,3,4</code> <br />
<code className='keywords'>for</code> x in <code className='keywords'>range</code>(5): <br />
&nbsp;<code className='library'> print</code>(x) <br /> <br />

<code className='comment'># Prints out 3,4,5</code> <br />
<code className='keywords'>for</code> x in <code className='keywords'>range</code>(3, 6): <br />
&nbsp;  <code className='library'>print</code>(x) <br /> <br /> 

<code className='comment'># Prints out 3,5,7</code> <br /> <br />
<code className='keywords'>for</code> x in <code className='keywords'>range</code>(3, 8, 2): <br /> 
&nbsp;   <code className='library'>print(x)</code><br />
</div>
<h3>Output</h3>
<div className='output'>
0 <br /> 1 <br />2 <br />3 <br />4 <br />3 <br />4 <br />5 <br />3 <br /> 5 <br />7

</div>
<h3>"while" loops</h3>
While loops repeat as long as a certain boolean condition is met. For example: <br />
<div className='containers'>
<code className='comment'># Prints out 0,1,2,3,4</code> <br /> <br />
count = 0<br />
<code className='keywords'>while</code> count &lt; 5:<br />
&nbsp;<code className='keywords'>print</code>(count)<br />
&nbsp;  count += 1 <br /> <code className='comment'># This is the same as count = count + 1</code>
</div>
<div className='output'>
0 <br /> 1 <br />2 <br />3 <br />4 

</div>
<h3>"break" and "continue" statements</h3>
break is used to exit a for loop or a while loop, whereas continue is used to skip the current block, and return to the "for" or "while" statement. A few examples:

<div className='containers'>
<code className='comment'># Prints out 0,1,2,3,4</code> <br />
<br /> <br />
count = 0 <br />
<code className='keywords'>while</code> True: <br />
&nbsp;<code className='library'>   print</code>(count) <br />
&nbsp;  count += 1 <br />
    <code className='keywords'>   if </code>count &gt;= 5:  <br /><br />
    &nbsp; <code className='library'>      break</code> <br />

   <code className='comment'># Prints out only odd numbers - 1,3,5,7,9 </code> <br />
    <code className='keywords'>for</code> x in <code className='keywords'>range</code>(10): <br />
    <code className='comment'> # Check if x is even</code> <br />
    &nbsp; <code className='keywords'>if</code> x % 2 == 0: <br />
    &nbsp; <code className='keywords'> continue</code> <br />
    &nbsp;  <code className='library'>  print(x)</code> <br />
</div> <br />
<div className='output'>
0 <br /> 1 <br />2 <br />3 <br />4  <br /> 1 <br />3 <br />5 <br />7 <br /> 9

</div>
<h3>Can we use "else" clause for loops?</h3>
Unlike languages like C,CPP.. we can use else for loops. When the loop condition of "for" or "while" statement fails then code part in "else" is executed. If a break statement is executed inside the for loop then the "else" part is skipped. Note that the "else" part is executed even if there is a continue statement.
        <div className='containers'>
        <code className='comment'>   # Prints out 0,1,2,3,4 and then it prints "count value reached 5" </code> <br />
        <br />
count=0 <br />
<code className='keywords'> while</code>(count&lt;5): <br />
&nbsp;   print(count) <br />
&nbsp;  count +=1 <br />
    <code className='keywords'> else:</code> <br />
    &nbsp; <code className='library'> print</code>("count value reached %d" %(count)) <br />
    <br />
# Prints out 1,2,3,4 <br />
<code className='keywords'> for</code> i in <code className='keywords'>range</code>(1, 10): <br />
&nbsp;<code className='keywords'>  if</code>(i%5==0): <br />
&nbsp;&nbsp;&nbsp; break <br />
&nbsp;&nbsp;&nbsp;    <code className='library'>  print</code>(i) <br />
    <code className='keywords'> else:</code> <br />
    &nbsp;&nbsp;  <code className='keywords'>  print</code>("this is not printed because for loop is terminated because of break but not due to fail in condition" <br />
        </div>
        <div className='output'>
        0 <br />1<br />2<br />3<br />4<br />count value reached 5<br />1<br />2<br />3<br />4<br />
        </div>
       
        </div>
    )
}

export default Loops
